import { render, staticRenderFns } from "./PricingSummary.vue?vue&type=template&id=15dab29d&scoped=true"
import script from "./PricingSummary.vue?vue&type=script&lang=js"
export * from "./PricingSummary.vue?vue&type=script&lang=js"
import style0 from "./PricingSummary.vue?vue&type=style&index=0&id=15dab29d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dab29d",
  null
  
)

export default component.exports